import { FC, useState } from "react"
import styles from "./datePeriodPicker.module.scss"
import { DatePicker } from "../../components/datePicker/datePicker";
import { DateTime } from "luxon";

export interface IDatePeriod {
    startDate: DateTime | null,
    endDate: DateTime | null
}

interface IDatePeriodPickerProps{
    period?: IDatePeriod,
    onPeriodChange?: (value: IDatePeriod) => void
    disabled?: boolean
    calendarHeight?: number
    withTime?: boolean
}

export const MinDateText = '1900-01-01'
export const MaxDateText = '2999-12-31'

export const MinDate = DateTime.fromFormat('1900-01-01 00:00', 'yyyy-MM-dd HH:mm');
export const MaxDate = DateTime.fromFormat('2999-12-31 23:59', 'yyyy-MM-dd HH:mm');

const DatePeriodPicker:FC<IDatePeriodPickerProps> = (props) => {
    const [incorrectPeriod, setIncorrectPeriod] = useState<boolean>(false);

    return (
        <div className={styles.datePeriodPicker}>
            <DatePicker 
                date={props.period?.startDate} 
                onBlur={value => {
                    const startDate = value?.day ? value : MinDate;

                    if ((startDate as DateTime) > (props.period?.endDate as DateTime)) {
                        setIncorrectPeriod(true);
                        props.onPeriodChange?.({startDate, endDate: value} as IDatePeriod);
                    } else {
                        setIncorrectPeriod(false);
                        props.onPeriodChange?.({startDate, endDate: props.period?.endDate} as IDatePeriod);
                    }
                }}
                incorrectPeriod={incorrectPeriod}
                disabled={props.disabled}
                minDate={MinDateText}
                maxDate={MaxDateText}
                inputStyle={{height: props.calendarHeight}}
                clearButtonStyle={{height: props.calendarHeight}}
                withTime={props.withTime}
                isStartDate={true}
            />
            <div className={styles.separator}>一</div>
            <DatePicker 
                date={props.period?.endDate} 
                onBlur={value => {
                    const endDate = value?.day ? value : MaxDate;

                    if ((endDate as DateTime) < (props.period?.startDate as DateTime)) {
                        setIncorrectPeriod(true);
                        props.onPeriodChange?.({startDate: value, endDate} as IDatePeriod)
                    } else {
                        setIncorrectPeriod(false);
                        props.onPeriodChange?.({startDate: props.period?.startDate, endDate} as IDatePeriod)
                    }
                }}
                incorrectPeriod={incorrectPeriod}
                disabled={props.disabled}
                minDate={MinDateText}
                maxDate={MaxDateText}
                inputStyle={{height: props.calendarHeight}}
                clearButtonStyle={{height: props.calendarHeight}}
                withTime={props.withTime}
                isStartDate={false}
            />
        </div>
    )
}
export default DatePeriodPicker